import 'Styles/forumview.scss';
import 'Styles/homepage.scss';


import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import rootViewSelector from 'Selectors/rootViewSelector';

import { pingServer } from 'Actions/GlobalMetaActions';
import { receiveGlobalMeta } from 'Actions/MetaActions';
import { resetWidgets } from 'Actions/WidgetActions';

import { onPageView, trackPageView } from 'Actions/adsActions';

import WidgetContainerComponent from 'Components/widgets/WidgetContainerComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

class RootViewComponent extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.props.dispatch( resetWidgets() );
		this.props.dispatch( pingServer() );
	}

	componentDidMount() {
		// Do not load root if we are on first load and we need to load other page
		if(
			this.props.firstLoad &&
			( this.props.initialRoute || this.props.userSettings.landingPage !== 'home' )
		) {
			return;
		}

		window.scrollTo(0, 0);

		// Setting Header title
		this.props.dispatch( receiveGlobalMeta( null, this.props.forumSite.f_title ) );
		// trigger ad updates
		this.props.dispatch( onPageView() );
		// Record the Google Analytics pageview
		this.props.dispatch( trackPageView() );
	}

	componentWillUnmount() {
		this.props.dispatch( resetWidgets() );
	}

	getRootWidgets = () => {
		let widgets = [];

		widgets.push( <WidgetContainerComponent key="1" widgetName={ 'Active Topics' } type="activeTopics" /> );
		widgets.push( <WidgetContainerComponent key="2" widgetName={ 'Popular Images' } type="popularImages" /> );
		widgets.push( <WidgetContainerComponent key="3" widgetName={ 'Popular Threads' } type="popularTopics" /> );
		widgets.push( <WidgetContainerComponent key="4" widgetName={ 'Vendor Topics' } type="vendorTopics" /> );

		return widgets;
	};

	initialView = () => {
		const { forumSite } = this.props;
		return [
			<div className="coverphoto" key="coverphoto">
				<img className="no-ad" src={forumSite.cover_photo} />
			</div>,
			<div className="detail" key="detail">
				<div className="title">
					{forumSite.f_title}
				</div>
				<div className="url">
					{forumSite.f_url}
				</div>
			</div>,
			<LoaderCss key="loader" />
		];
	};

	render() {
		const content = this.props.userInfo === null ?
			<div className="forumsIndex nolinks">{ this.getRootWidgets() }</div> : this.initialView();

		return (
			<div className="forumRoot nolinks">
				{ content }
			</div>
		);
	}
}

RootViewComponent.propTypes = {
	forumSite: PropTypes.shape({
		cover_photo: PropTypes.string.isRequired,
		f_title: PropTypes.string.isRequired,
		f_url: PropTypes.string.isRequired
	})
};

export default connect( rootViewSelector )( RootViewComponent );



// WEBPACK FOOTER //
// ./src/components/RootViewComponent.js